import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  margin-bottom: 15px;
  width: 100%;
`;

const BgImage = styled.image`
  img {
    display: block;
    width: 100%;
    border-radius: 4px;
  }
`;

const Description = styled.div`
  background: linear-gradient(0deg, #2e2e2e, #2e2e2e), #c4c4c4;
  border-radius: 4px;
  color: #ffffff;
  overflow: hidden;
  padding: 16px;

  h4 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    text-transform: capitalize;
    font-size: 20px;
  }

  h3 {
    margin: 4px;
    font-family: ${props => props.theme.fonts.subheading};
    font-size: 16px;
    font-weight: normal;
  }
`;

function CatalogueCard(props) {
  return (
    <Container>
      <BgImage>
        <img src={props.image} />
      </BgImage>
      <Description>
        <h4>{props.name}</h4>
        <div
          css={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse cx="7.77352" cy="7" rx="6.91195" ry="7" fill="white" />
            <path
              d="M7.89258 10.8926H5.85645V3.35352H7.8291C8.81217 3.35352 9.54134 3.55371 10.0166 3.9541C10.5765 4.42611 10.8564 5.08203 10.8564 5.92188C10.8564 6.83659 10.5586 7.51855 9.96289 7.96777C9.55599 8.27051 8.97168 8.42188 8.20996 8.42188H7.89258V10.8926ZM7.89258 6.72754L7.98535 6.73242C8.23275 6.73242 8.42969 6.65755 8.57617 6.50781C8.72266 6.35482 8.7959 6.14648 8.7959 5.88281C8.7959 5.6224 8.72428 5.41081 8.58105 5.24805C8.43783 5.08203 8.25553 4.99902 8.03418 4.99902H7.89258V6.72754Z"
              fill="black"
            />
          </svg>
          <h3>{props.point}</h3>
        </div>
      </Description>
    </Container>
  );
}

export default CatalogueCard;
